import { render } from "./PhoneIcon.vue?vue&type=template&id=514c29cc&scoped=true"
import script from "./PhoneIcon.vue?vue&type=script&lang=js"
export * from "./PhoneIcon.vue?vue&type=script&lang=js"

import "./PhoneIcon.vue?vue&type=style&index=0&id=514c29cc&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514c29cc"]])

export default __exports__